// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   OW App Manager - Styles
   Primary: #0066CC | Professional Blue/White Theme
   ======================================== */

/* Reset & Base */
*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f0f4f8;
  color: #1a2332;
}

.App {
  min-height: 100vh;
}

/* ========================================
   Loading Spinner
   ======================================== */

.app-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f4f8;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ========================================
   Login Page
   ======================================== */

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0066cc 0%, #004999 100%);
  padding: 20px;
}

.login-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  padding: 48px 40px;
  width: 100%;
  max-width: 420px;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #0066cc;
  margin: 0 0 8px 0;
}

.login-header p {
  font-size: 15px;
  color: #64748b;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #1a2332;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}

.form-group input:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.15);
}

.form-group input::placeholder {
  color: #94a3b8;
}

.login-button {
  padding: 14px;
  background: #0066cc;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  margin-top: 4px;
}

.login-button:hover {
  background: #0055aa;
}

.login-button:active {
  transform: scale(0.98);
}

.login-button:disabled {
  background: #94a3b8;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

/* ========================================
   Dashboard
   ======================================== */

.dashboard {
  min-height: 100vh;
  background-color: #f0f4f8;
}

/* Header */
.dashboard-header {
  background: #0066cc;
  color: #ffffff;
  padding: 0 32px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3);
}

.header-left h1 {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-name {
  font-size: 14px;
  opacity: 0.9;
}

.logout-button {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Content */
.dashboard-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 32px;
}

/* Filter Bar */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.filter-toggle {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.filter-button {
  padding: 10px 24px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-button.active {
  background: #0066cc;
  color: #ffffff;
}

.filter-button:hover:not(.active) {
  background: #f1f5f9;
  color: #1a2332;
}

.refresh-button {
  padding: 10px 20px;
  background: #ffffff;
  color: #0066cc;
  border: 1px solid #0066cc;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.refresh-button:hover {
  background: #0066cc;
  color: #ffffff;
}

.refresh-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Error Banner */
.error-banner {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
}

/* Table Container */
.table-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* Loading & Empty States */
.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
}

.loading-state .spinner {
  margin-bottom: 16px;
}

.empty-state p,
.loading-state p {
  font-size: 15px;
  margin: 0;
}

/* Table */
.portings-table {
  width: 100%;
  border-collapse: collapse;
}

.portings-table thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.portings-table th {
  padding: 14px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.portings-table td {
  padding: 14px 16px;
  font-size: 14px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.portings-table tbody tr:hover {
  background: #f8fafc;
}

.portings-table tbody tr.row-success {
  background: #f0fdf4;
}

.portings-table tbody tr:last-child td {
  border-bottom: none;
}

.cell-id {
  font-weight: 600;
  color: #0066cc;
  white-space: nowrap;
}

.cell-phone {
  font-family: 'SF Mono', 'Consolas', 'Monaco', monospace;
  font-size: 13px;
  white-space: nowrap;
}

.cell-date {
  white-space: nowrap;
  font-size: 13px;
  color: #64748b;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-gray {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.badge-yellow {
  background: #fefce8;
  color: #a16207;
  border: 1px solid #fde68a;
}

.badge-green {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.badge-red {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

/* Status Select */
.status-select {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  color: #334155;
  background: #ffffff;
  cursor: pointer;
  outline: none;
  min-width: 150px;
  transition: border-color 0.2s;
}

.status-select:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);
}

.status-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Notes Input */
.notes-input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  color: #334155;
  width: 100%;
  min-width: 180px;
  outline: none;
  transition: border-color 0.2s;
}

.notes-input:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);
}

.notes-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.notes-input::placeholder {
  color: #94a3b8;
}

/* Update Button */
.update-button {
  padding: 8px 16px;
  background: #0066cc;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.update-button:hover:not(:disabled) {
  background: #0055aa;
}

.update-button:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.update-button.success {
  background: #16a34a;
}

/* ========================================
   Edit Icon Button
   ======================================== */

.edit-icon-btn {
  background: none;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 18px;
  padding: 6px 10px;
  color: #0066cc;
  transition: all 0.2s;
  line-height: 1;
}

.edit-icon-btn:hover {
  background: #0066cc;
  color: #ffffff;
  border-color: #0066cc;
}

/* ========================================
   Modal
   ======================================== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalIn 0.2s ease-out;
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a2332;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #94a3b8;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #334155;
}

.modal-body {
  padding: 24px;
}

.modal-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.modal-info-item.full-width {
  grid-column: 1 / -1;
}

.modal-label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-value {
  font-size: 14px;
  color: #1a2332;
  font-weight: 500;
}

.modal-value.mono {
  font-family: 'SF Mono', 'Consolas', 'Monaco', monospace;
}

.modal-divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 20px 0;
}

.modal-form-group {
  margin-bottom: 16px;
}

.modal-form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.modal-form-group .status-select {
  width: 100%;
}

.commission-hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  padding: 8px 12px;
  border-radius: 6px;
}

.notes-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #334155;
  outline: none;
  resize: vertical;
  transition: border-color 0.2s;
}

.notes-textarea:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);
}

.notes-textarea::placeholder {
  color: #94a3b8;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
}

.modal-cancel-btn {
  padding: 10px 20px;
  background: #ffffff;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-cancel-btn:hover {
  background: #f1f5f9;
  color: #334155;
}

.modal-save-btn {
  padding: 10px 24px;
  background: #0066cc;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-save-btn:hover:not(:disabled) {
  background: #0055aa;
}

.modal-save-btn:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

/* ========================================
   Responsive
   ======================================== */

@media (max-width: 1200px) {
  .dashboard-content {
    padding: 20px 16px;
  }

  .table-container {
    overflow-x: auto;
  }

  .portings-table {
    min-width: 900px;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 0 16px;
  }

  .header-left h1 {
    font-size: 17px;
  }

  .user-name {
    display: none;
  }

  .filter-bar {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .filter-toggle {
    display: flex;
  }

  .filter-button {
    flex: 1 1;
    text-align: center;
  }

  .refresh-button {
    text-align: center;
  }

  .login-card {
    padding: 32px 24px;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 24px 20px;
    border-radius: 8px;
  }

  .login-header h1 {
    font-size: 24px;
  }
}

/* ========================================
   Header nav tabs
   ======================================== */
.header-left {
  display: flex;
  align-items: center;
  gap: 28px;
}

.header-nav {
  display: flex;
  gap: 4px;
}

.nav-tab {
  padding: 8px 16px;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-tab:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.nav-tab.active {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

/* ========================================
   Search + primary button
   ======================================== */
.search-form {
  display: flex;
  gap: 8px;
  align-items: center;
}

.search-input {
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  min-width: 280px;
  outline: none;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #0066cc;
}

.primary-button {
  padding: 10px 18px;
  background: #0066cc;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.primary-button:hover:not(:disabled) {
  background: #0052a6;
}

.primary-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========================================
   Small action buttons
   ======================================== */
.small-btn {
  padding: 6px 12px;
  background: #f1f5f9;
  color: #1a2332;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.small-btn:hover:not(:disabled) {
  background: #e2e8f0;
}

.small-btn.success {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.small-btn.success:hover:not(:disabled) {
  background: #bbf7d0;
}

.small-btn.danger {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

.small-btn.danger:hover:not(:disabled) {
  background: #fecaca;
}

.small-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========================================
   Text input (modals)
   ======================================== */
.text-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.text-input:focus {
  border-color: #0066cc;
}

/* ========================================
   Pagination
   ======================================== */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1a2332;
  cursor: pointer;
  transition: all 0.15s;
}

.page-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #0066cc;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #64748b;
}

/* ========================================
   Stats cards
   ======================================== */
.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1 1;
  min-width: 180px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #1a2332;
}

.stat-value.green { color: #166534; }
.stat-value.red { color: #991b1b; }

/* ========================================
   Misc
   ======================================== */
.row-inactive {
  opacity: 0.55;
}

.pending-tag {
  color: #b45309;
  font-size: 12px;
}

@media (max-width: 768px) {
  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .search-input {
    min-width: 0;
    flex: 1 1;
  }
  .stats-row {
    flex-direction: column;
  }
}

/* ========================================
   Businesses / codes
   ======================================== */
.code-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  font-weight: 700;
  letter-spacing: 1px;
  background: #eef4fc;
  color: #0066cc;
  border: 1px solid #cfe0f5;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  -webkit-user-select: all;
          user-select: all;
}

.code-chip:hover { background: #e0ecfb; }

.root-tag {
  font-size: 11px;
  font-weight: 700;
  color: #166534;
  background: #dcfce7;
  border-radius: 4px;
  padding: 2px 6px;
  margin-left: 6px;
  text-transform: uppercase;
}

.admin-line { font-size: 13px; }
.admin-email { color: #94a3b8; font-size: 12px; }

.section-hint {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  max-width: 640px;
}

.code-banner {
  background: #eef4fc;
  border: 1px solid #cfe0f5;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #1a2332;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.code-banner-hint { color: #64748b; }

.user-business {
  font-size: 13px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 4px 10px;
}

/* Export / date range bar */
.export-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
}
.export-label { font-weight: 600; color: #1a2332; font-size: 14px; }
.date-field {
  display: flex; flex-direction: column; font-size: 11px; color: #64748b; gap: 3px;
}
.date-input {
  padding: 7px 10px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 14px; color: #1a2332;
}
.date-input:focus { outline: none; border-color: #0066cc; }
.export-hint { color: #94a3b8; font-size: 12px; margin-left: auto; }

.filter-apply-btn {
  padding: 9px 18px;
  background: #0066cc;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-end;
}
.filter-apply-btn:hover { background: #0052a6; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;6CAG6C;;AAE7C,iBAAiB;AACjB;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV;;gCAE8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;6CAE6C;;AAE7C;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;6CAE6C;;AAE7C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;6CAE6C;;AAE7C;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB,cAAc,EAAE;AACpC,kBAAkB,cAAc,EAAE;;AAElC;;6CAE6C;AAC7C;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,YAAY;IACZ,SAAO;EACT;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;;6CAE6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qEAAqE;EACrE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,cAAc,eAAe,EAAE;AAC/B,eAAe,cAAc,EAAE,eAAe,EAAE;;AAEhD;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,oBAAoB,cAAc,EAAE;;AAEpC;EACE,eAAe;EACf,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gBAAgB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE;EACE,aAAa,EAAE,sBAAsB,EAAE,eAAe,EAAE,cAAc,EAAE,QAAQ;AAClF;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc;AACnG;AACA,oBAAoB,aAAa,EAAE,qBAAqB,EAAE;AAC1D,eAAe,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAEnE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA,0BAA0B,mBAAmB,EAAE","sourcesContent":["/* ========================================\n   OW App Manager - Styles\n   Primary: #0066CC | Professional Blue/White Theme\n   ======================================== */\n\n/* Reset & Base */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f0f4f8;\n  color: #1a2332;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* ========================================\n   Loading Spinner\n   ======================================== */\n\n.app-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f0f4f8;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #0066cc;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ========================================\n   Login Page\n   ======================================== */\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0066cc 0%, #004999 100%);\n  padding: 20px;\n}\n\n.login-card {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  padding: 48px 40px;\n  width: 100%;\n  max-width: 420px;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.login-header h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0066cc;\n  margin: 0 0 8px 0;\n}\n\n.login-header p {\n  font-size: 15px;\n  color: #64748b;\n  margin: 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #1a2332;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  outline: none;\n}\n\n.form-group input:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.15);\n}\n\n.form-group input::placeholder {\n  color: #94a3b8;\n}\n\n.login-button {\n  padding: 14px;\n  background: #0066cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n  margin-top: 4px;\n}\n\n.login-button:hover {\n  background: #0055aa;\n}\n\n.login-button:active {\n  transform: scale(0.98);\n}\n\n.login-button:disabled {\n  background: #94a3b8;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* ========================================\n   Dashboard\n   ======================================== */\n\n.dashboard {\n  min-height: 100vh;\n  background-color: #f0f4f8;\n}\n\n/* Header */\n.dashboard-header {\n  background: #0066cc;\n  color: #ffffff;\n  padding: 0 32px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3);\n}\n\n.header-left h1 {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-name {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.logout-button {\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* Content */\n.dashboard-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px 32px;\n}\n\n/* Filter Bar */\n.filter-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.filter-toggle {\n  display: flex;\n  background: #ffffff;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.filter-button {\n  padding: 10px 24px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.filter-button.active {\n  background: #0066cc;\n  color: #ffffff;\n}\n\n.filter-button:hover:not(.active) {\n  background: #f1f5f9;\n  color: #1a2332;\n}\n\n.refresh-button {\n  padding: 10px 20px;\n  background: #ffffff;\n  color: #0066cc;\n  border: 1px solid #0066cc;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.refresh-button:hover {\n  background: #0066cc;\n  color: #ffffff;\n}\n\n.refresh-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Error Banner */\n.error-banner {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* Table Container */\n.table-container {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n/* Loading & Empty States */\n.loading-state,\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #64748b;\n}\n\n.loading-state .spinner {\n  margin-bottom: 16px;\n}\n\n.empty-state p,\n.loading-state p {\n  font-size: 15px;\n  margin: 0;\n}\n\n/* Table */\n.portings-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.portings-table thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.portings-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.portings-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #334155;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.portings-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.portings-table tbody tr.row-success {\n  background: #f0fdf4;\n}\n\n.portings-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.cell-id {\n  font-weight: 600;\n  color: #0066cc;\n  white-space: nowrap;\n}\n\n.cell-phone {\n  font-family: 'SF Mono', 'Consolas', 'Monaco', monospace;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.cell-date {\n  white-space: nowrap;\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-gray {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n}\n\n.badge-yellow {\n  background: #fefce8;\n  color: #a16207;\n  border: 1px solid #fde68a;\n}\n\n.badge-green {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.badge-red {\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n/* Status Select */\n.status-select {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #334155;\n  background: #ffffff;\n  cursor: pointer;\n  outline: none;\n  min-width: 150px;\n  transition: border-color 0.2s;\n}\n\n.status-select:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);\n}\n\n.status-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Notes Input */\n.notes-input {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #334155;\n  width: 100%;\n  min-width: 180px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.notes-input:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);\n}\n\n.notes-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.notes-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Update Button */\n.update-button {\n  padding: 8px 16px;\n  background: #0066cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.update-button:hover:not(:disabled) {\n  background: #0055aa;\n}\n\n.update-button:disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n}\n\n.update-button.success {\n  background: #16a34a;\n}\n\n/* ========================================\n   Edit Icon Button\n   ======================================== */\n\n.edit-icon-btn {\n  background: none;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 6px 10px;\n  color: #0066cc;\n  transition: all 0.2s;\n  line-height: 1;\n}\n\n.edit-icon-btn:hover {\n  background: #0066cc;\n  color: #ffffff;\n  border-color: #0066cc;\n}\n\n/* ========================================\n   Modal\n   ======================================== */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalIn 0.2s ease-out;\n}\n\n@keyframes modalIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a2332;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.modal-close:hover {\n  color: #334155;\n}\n\n.modal-body {\n  padding: 24px;\n}\n\n.modal-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.modal-info-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.modal-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.modal-value {\n  font-size: 14px;\n  color: #1a2332;\n  font-weight: 500;\n}\n\n.modal-value.mono {\n  font-family: 'SF Mono', 'Consolas', 'Monaco', monospace;\n}\n\n.modal-divider {\n  border: none;\n  border-top: 1px solid #e2e8f0;\n  margin: 20px 0;\n}\n\n.modal-form-group {\n  margin-bottom: 16px;\n}\n\n.modal-form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.modal-form-group .status-select {\n  width: 100%;\n}\n\n.commission-hint {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #15803d;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  padding: 8px 12px;\n  border-radius: 6px;\n}\n\n.notes-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #334155;\n  outline: none;\n  resize: vertical;\n  transition: border-color 0.2s;\n}\n\n.notes-textarea:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);\n}\n\n.notes-textarea::placeholder {\n  color: #94a3b8;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.modal-cancel-btn {\n  padding: 10px 20px;\n  background: #ffffff;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modal-cancel-btn:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.modal-save-btn {\n  padding: 10px 24px;\n  background: #0066cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modal-save-btn:hover:not(:disabled) {\n  background: #0055aa;\n}\n\n.modal-save-btn:disabled {\n  background: #94a3b8;\n  cursor: not-allowed;\n}\n\n/* ========================================\n   Responsive\n   ======================================== */\n\n@media (max-width: 1200px) {\n  .dashboard-content {\n    padding: 20px 16px;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .portings-table {\n    min-width: 900px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-header {\n    padding: 0 16px;\n  }\n\n  .header-left h1 {\n    font-size: 17px;\n  }\n\n  .user-name {\n    display: none;\n  }\n\n  .filter-bar {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .filter-toggle {\n    display: flex;\n  }\n\n  .filter-button {\n    flex: 1;\n    text-align: center;\n  }\n\n  .refresh-button {\n    text-align: center;\n  }\n\n  .login-card {\n    padding: 32px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 24px 20px;\n    border-radius: 8px;\n  }\n\n  .login-header h1 {\n    font-size: 24px;\n  }\n}\n\n/* ========================================\n   Header nav tabs\n   ======================================== */\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n.header-nav {\n  display: flex;\n  gap: 4px;\n}\n\n.nav-tab {\n  padding: 8px 16px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.75);\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.nav-tab:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\n.nav-tab.active {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n/* ========================================\n   Search + primary button\n   ======================================== */\n.search-form {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.search-input {\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  min-width: 280px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.search-input:focus {\n  border-color: #0066cc;\n}\n\n.primary-button {\n  padding: 10px 18px;\n  background: #0066cc;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.primary-button:hover:not(:disabled) {\n  background: #0052a6;\n}\n\n.primary-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ========================================\n   Small action buttons\n   ======================================== */\n.small-btn {\n  padding: 6px 12px;\n  background: #f1f5f9;\n  color: #1a2332;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.small-btn:hover:not(:disabled) {\n  background: #e2e8f0;\n}\n\n.small-btn.success {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.small-btn.success:hover:not(:disabled) {\n  background: #bbf7d0;\n}\n\n.small-btn.danger {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.small-btn.danger:hover:not(:disabled) {\n  background: #fecaca;\n}\n\n.small-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ========================================\n   Text input (modals)\n   ======================================== */\n.text-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.text-input:focus {\n  border-color: #0066cc;\n}\n\n/* ========================================\n   Pagination\n   ======================================== */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.page-btn {\n  padding: 8px 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1a2332;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.page-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #0066cc;\n}\n\n.page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  font-size: 14px;\n  color: #64748b;\n}\n\n/* ========================================\n   Stats cards\n   ======================================== */\n.stats-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.stat-card {\n  flex: 1;\n  min-width: 180px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.stat-label {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 26px;\n  font-weight: 700;\n  color: #1a2332;\n}\n\n.stat-value.green { color: #166534; }\n.stat-value.red { color: #991b1b; }\n\n/* ========================================\n   Misc\n   ======================================== */\n.row-inactive {\n  opacity: 0.55;\n}\n\n.pending-tag {\n  color: #b45309;\n  font-size: 12px;\n}\n\n@media (max-width: 768px) {\n  .header-left {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  .search-input {\n    min-width: 0;\n    flex: 1;\n  }\n  .stats-row {\n    flex-direction: column;\n  }\n}\n\n/* ========================================\n   Businesses / codes\n   ======================================== */\n.code-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;\n  font-weight: 700;\n  letter-spacing: 1px;\n  background: #eef4fc;\n  color: #0066cc;\n  border: 1px solid #cfe0f5;\n  padding: 4px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  user-select: all;\n}\n\n.code-chip:hover { background: #e0ecfb; }\n\n.root-tag {\n  font-size: 11px;\n  font-weight: 700;\n  color: #166534;\n  background: #dcfce7;\n  border-radius: 4px;\n  padding: 2px 6px;\n  margin-left: 6px;\n  text-transform: uppercase;\n}\n\n.admin-line { font-size: 13px; }\n.admin-email { color: #94a3b8; font-size: 12px; }\n\n.section-hint {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  max-width: 640px;\n}\n\n.code-banner {\n  background: #eef4fc;\n  border: 1px solid #cfe0f5;\n  border-radius: 10px;\n  padding: 14px 18px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #1a2332;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.code-banner-hint { color: #64748b; }\n\n.user-business {\n  font-size: 13px;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 4px 10px;\n}\n\n/* Export / date range bar */\n.export-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n}\n.export-label { font-weight: 600; color: #1a2332; font-size: 14px; }\n.date-field {\n  display: flex; flex-direction: column; font-size: 11px; color: #64748b; gap: 3px;\n}\n.date-input {\n  padding: 7px 10px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 14px; color: #1a2332;\n}\n.date-input:focus { outline: none; border-color: #0066cc; }\n.export-hint { color: #94a3b8; font-size: 12px; margin-left: auto; }\n\n.filter-apply-btn {\n  padding: 9px 18px;\n  background: #0066cc;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  align-self: flex-end;\n}\n.filter-apply-btn:hover { background: #0052a6; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
